import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [seconds, setSeconds] = useState(1800); // ~30:00
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const display = `${minutes}:${secs.toString().padStart(2, '0')}`;
  return <div className="w-full bg-[#3dbb6e] py-5 md:py-6" data-id="element-502">
      <div className="flex items-center justify-center gap-4 md:gap-6 px-4" data-id="element-503">
        <span className="text-black font-bold text-lg md:text-xl tracking-wide flex items-center gap-2.5" data-id="element-504">
          <span className="text-2xl md:text-3xl" data-id="element-505">🔥</span>
          OFERTA ACTIVA POR TIEMPO LIMITADO
        </span>
        <span className="inline-flex items-center px-5 py-2 rounded-full bg-white/25 text-black font-bold text-lg md:text-xl tabular-nums tracking-wider" data-id="element-506">
          {display}
        </span>
        <span className="text-2xl md:text-3xl" data-id="element-507">🔥</span>
      </div>
    </div>;
}